/* eslint-disable import/order */
import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { boardsDirectoryResource } from '@jira/router-resources__directories-boards/src/boardsDirectoryResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { boardsDirectoryRedirectRoute } from '@jira/router-routes__directories-routes/src/boardsDirectoryRedirectRoute.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { BoardsDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { LazyBoardsDirectory } from './ui/boards/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const BoardsDirectoryRedirect = () => <ScreenRedirect to="/jira/boards" />;

export const boardsDirectoryRedirectRouteEntry: Route = createEntry(
	boardsDirectoryRedirectRoute,
	() => ({
		group: 'directories',
		// eslint-disable-next-line no-restricted-syntax
		component: BoardsDirectoryRedirect,
		skeleton: BoardsDirectorySkeleton,
		layout: globalLayout,
		resources: [...getNavigationResources(), boardsDirectoryResource],

		navigation: {
			menuId: MenuIdProjects,
		},

		forPaint: [LazyAtlassianNavigation, LazyBoardsDirectory],
		isRedirect: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
